// Artwork: Charte Graphique/Cartes/Visuel1.pdf, exported at its trim box.
// Both upload previews share the same photo frame and official artwork.
export default function StudentCardPreview({ photoUrl, lang, modal = false }) {
  const english = lang === 'en';
  return (
    <figure className="identityCardPreviewWrapper studentCard">
      <div className={`identityCardPreview${modal ? ' identityCardPreview--modal' : ''}`}>
        <img
          src="/brand/ices/carte-etudiante-recto.png"
          alt={english ? 'ICES student card — front' : 'Carte étudiante ICES — recto'}
          className="identityCardPreview__background"
        />
        <div className="identityCardPreview__photo">
          <img src={photoUrl} alt={english ? 'Identity photo preview' : "Aperçu de la photo d’identité"} />
        </div>
      </div>
      <figcaption className="identityCardPreview__caption">
        {english ? 'Student card preview · Your personal details will be added when the card is issued.' : 'Aperçu de votre carte étudiante · Vos informations seront ajoutées lors de son édition.'}
      </figcaption>
    </figure>
  );
}
